<template>
  <div>
    <div class="d-flex justify-content-between mb-3">
      <div>
        <div class="section-title">
          {{ $t("view") }} {{ $tc("user", 1) }} {{ $tc("shift", 2) }}
        </div>
        <div class="section-subTitle my-2"></div>
      </div>
      <div>
        <router-link class="btn-blue" to="user-shifts"
          >{{ $tc("usersshift", 2) }} {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div class="white-wrapper mb-0">
      <div class="row">
        <div class="col-12 mb-4">
          <div class="row">
            <!-- SELECT CINEMA DROPDOWN -->

            <div class="col-md-6 mb-4">
              <div class="dropdown-curve-container">
                <label :class="selectedCinema.length > 0 ? 'shift-up' : ''"
                  >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
                >
                <b-dropdown
                  :disabled="isRoleID"
                  :text="selectedCinema"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Cinema"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchCinema()"
                      v-on:keydown="onSearchCinema()"
                      v-model="searchCinema"
                    />
                  </div>
                  <b-dropdown-item
                    v-for="(Cinema, CinemaIndex) in Cinemas"
                    :key="CinemaIndex"
                    v-on:click="onSelectCinema($event, Cinema)"
                    >{{ Cinema.cine_name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>

            <!-- <div class="col-3">
              <div class="dropdown-curve-container">
                <label class="shift-up">Select Cinema</label>
                <b-dropdown :text="selectedCinema" variant="dropdown-curve" class="w-100">
                  <b-dropdown-item
                    v-for="(Cinema, CinemaIndex) in Cinemas"
                    :key="CinemaIndex"
                    v-on:click="onSelectCinema($event, Cinema)"
                  >{{ Cinema.cine_name }}</b-dropdown-item>
                </b-dropdown>
              </div>
            </div>-->

            <div class="col-3">
              <div class="dropdown-curve-container">
                <label :class="selectedUser.length > 0 ? 'shift-up' : ''"
                  >{{ $t("select") }} {{ $tc("user", 1) }}</label
                >
                <b-dropdown
                  :text="selectedUser"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Cinema"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchUsers()"
                      v-on:keydown="onSearchUsers()"
                      v-model="searchUser"
                    />
                  </div>
                  <b-dropdown-item
                    v-for="(user, userIndex) in Users"
                    :key="userIndex"
                    v-on:click="onSelectUser($event, user)"
                    >{{ user.first_name }} {{ user.last_name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>
          </div>
        </div>

        <div class="manage-user-shifts-container d-none">
          <div class="user-shift-drop-container">
            <div class="single-days-wrapper">
              <div class="empty-box"></div>
              <div
                class="individual-day"
                v-for="(indi, idKey) in 10"
                :key="idKey"
              >
                <div class="day-wrapper">
                  <div class="single-day-name">Sunday</div>
                  <div class="single-date">{{ idKey }} - Jan - 2019</div>
                </div>
                <div class="shifts-wrapper">
                  <div class="morning-shift">
                    <strong>M</strong>
                  </div>
                  <div class="afternoon-shift">
                    <strong>A</strong>
                  </div>
                  <div class="evening-shift">
                    <strong>E</strong>
                  </div>
                </div>
              </div>
            </div>

            <div class="rows-wrapper">
              <div class="user-shift-header">
                <div
                  class="header-pos-name"
                  v-for="(date, dateKey) in dates"
                  :key="dateKey"
                >
                  {{ date }}
                </div>
              </div>

              <div
                class="single-day-row"
                v-for="(singleDayRow, dayRowKey) in UserShifts"
                :key="dayRowKey"
              >
                <div
                  class="single-day-box"
                  v-for="(user, userKey) in UserShifts"
                  :key="userKey"
                >
                  <div class="user-shift-card">
                    <div class="small mb-1">
                      <!-- <strong>({{ user.up_employee_code }})</strong> -->
                      {{ user.first_name }} {{ user.last_name }}
                    </div>
                    <!-- <button class="btn-edit" v-b-modal.edit-user-shift>Edit</button> -->
                    <!-- <button class="btn-transparent ml-2" title="Delete Shift">
                      <img src="@/assets/img/icons/delete-red.svg" height="auto" width="14" alt />
                    </button>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <table
          class="view-details-table"
          v-for="(shifts, shiftKey) in UserShifts"
          :key="shiftKey"
        >
          <tr>
            <td>{{ $tc("shift", 1) }}</td>
            <td>{{ shifts.shift_name }}</td>
          </tr>

          <tr>
            <td>{{ $tc("shiftstartdate", 1) }}</td>
            <td>{{ shifts.us_start_date | dateparse }}</td>
          </tr>

          <tr>
            <td>{{ $tc("shiftenddate", 1) }}</td>
            <td>{{ shifts.us_end_date | dateparse }}</td>
          </tr>

          <tr>
            <td>{{ $tc("shifthours", 1) }}</td>
            <td>{{ shifts.shift_working_hrs }} hrs</td>
          </tr>

          <tr>
            <td>{{ $tc("shiftstartime", 1) }}</td>
            <td>{{ shifts.shift_start_time | time }}</td>
          </tr>

          <tr>
            <td>{{ $tc("shiftendtime", 1) }}</td>
            <td>{{ shifts.shift_end_time | time }}</td>
          </tr>

          <tr>
            <td>{{ $tc("concession", 1) }}</td>
            <td>{{ getConcessionLevelName(shifts.concession_level_id) }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <!-- <b-modal id="edit-user-shift" hide-footer title="Edit User Shift">
      <form>
        <div class="row">
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Username</div>
              <div class="col-8">
                <strong>John Doe</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">User Id</div>
              <div class="col-8">
                <strong>123456</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">On Leave</div>
              <div class="col-8">
                <strong>1 Jan, 2 Jan, 3 Jan</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Shift Date</div>
              <div class="col-8">
                <div class="input-material user-shift-datepicker">
                  <div class="add-datepicker">
                    <Datepicker :monday-first="true"
                      ref="programaticOpen"
                      clear-button
                      calendar-button="true"
                      v-model="selectedNewDate"
                      name="uniquename"
                    ></Datepicker>
                    <label :class="typeof selectedNewDate === 'object' ? 'active': ''">Date</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Shift</div>
              <div class="col-8">
                <select class="select-user-shift">
                  <option>Morning</option>
                  <option>Afternoon</option>
                  <option>Evening</option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-12 pt-3 text-center">
            <button class="btn-blue">Update</button>
          </div>
        </div>
      </form>
  </b-modal>-->
  <!-- </div> -->
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import { groupBy } from "lodash";

export default {
  data() {
    return {
      Concessions: [],
      isRoleID: true,
      selectedNewDate: "",
      selectedCinema: "",
      selectedUser: "",
      selectedLevel: "",
      selectedCounter: "",
      UserShifts: [],
      Users: [],
      dates: [],
      Cinemas: [],
      cinema_id: null,
      searchCinema: "",
      CinemasCopy: [],
      searchUser: "",
      UsersCopy: []
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.cinema_id = obj || null;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemas(obj);
    // this.getUsersList();
    // this.getConcessionLevelList();
  },
  mounted() {
    // this.getAllShiftsDates();
    // this.getShiftsList();
  },
  methods: {
    onSearchCinema() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            // TODO Enter Rate card variable name
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    onSearchUsers() {
      if (this.searchUser && this.searchUser.length > 0) {
        this.Users = this.UsersCopy.filter(x => {
          if (
            // TODO Enter Rate card variable name
            x.first_name.toLowerCase().includes(this.searchUser.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Users = this.UsersCopy;
      }
    },
    getCinemas: function(cine_id) {
      // let body = this.getRequestBody("GET", undefined, {
      //   GET: "/admin/",
      //   tableName: "ms_cinemas"
      // });
      // let body = {
      //   activekey: "cine_is_active"
      // };
      // MasterService.GlobalRequest(body)
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.selectedCinema = x.cine_name;
                // getConcessionLevelList(x.cine_id);
                this.onSelectCinema(null, x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    getConcessionLevelName: function(cl_id) {
      // console.log("cl_id :", cl_id);
      let concession_name = this.Concessions.filter(x => {
        if (x.cl_id == cl_id) {
          return x.cl_name;
        }
      });
      // console.log("co :", concession_name);
      return concession_name.length > 0 ? concession_name[0].cl_name : "-";
    },

    getConcessionLevelList: function() {
      this.Concessions = [];
      let payload = {
        tableName: "ms_concession_levels",
        // cl_id: clevel_id,
        cl_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          this.Concessions = data.Records;
        })
        .catch(error => {
          // Catch Error:
          console.log(error);
        });
      // return data.Records[0];
    },
    getAllShiftsDates: function() {
      this.dates = [];
      MasterService.GetAllUserShiftsDates()
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.dates = data.Records;
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getShiftsList: function(user_id) {
      this.UserShifts = [];
      let payload = {
        limit: null,
        curentPage: null,
        cinema_id: this.cinema_id
      };
      MasterService.GetAllUserShifts(payload)
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              let userShifts = data.Records;
              // console.log("userShifts :", userShifts);
              userShifts.map(x => {
                if (x.user_id == user_id) {
                  this.UserShifts.push(x);
                }
              });
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getUsersList: function(cinema_id) {
      // let body = this.getRequestBody("GET", undefined, {
      //   GET: "/admin/",
      //   tableName: "users"
      // });
      // if (cinema_id) {
      //   body[cinema_id] = cinema_id;
      // }
      MasterService.GetUsers({ cine_id: cinema_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Users = data.Records;
            this.UsersCopy = data.Records;
            this.Users = this.Users.filter(singleRole => {
              // console.log('singleRole :', singleRole.role_id != 2);
              // if (
              //   singleRole.role_id != 1 &&
              //   singleRole.role_id != 2 &&
              //   singleRole.role_id != 9
              // ) {
              //   return singleRole;
              // }
              if (
                (singleRole.role_id == 4 || singleRole.role_id == 8) &&
                singleRole.cinema_id == cinema_id
              ) {
                return singleRole;
              }
            });
            // console.log("Userss ", this.Users);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    // onSelectCinema: function(params) {
    //   this.selectedCinema = params;
    // },
    onSelectCinema: function(event, cinema) {
      this.selectedCinema = cinema.cine_name;
      this.selectedUser = "";
      this.UserShifts = [];
      this.getUsersList(cinema.cine_id);
    },
    onSelectUser: function(event, user) {
      this.selectedUser = user.first_name + user.last_name;
      this.getShiftsList(user.user_id);
    },
    onSelectLevel: function(params) {
      this.selectedLevel = params;
    },
    onSelectCounter: function(params) {
      this.selectedCounter = params;
    },
    clearSelectedDate: function() {
      this.selectedNewDate = "";
    }
  }
};
</script>

<style>
.user-shift-header {
  width: 100%;
  height: 40px;
  display: flex;
  border-bottom: 1px solid #d3d3d3;
}

.user-shift-header .header-pos-name {
  width: 175px;
  height: 100%;
  display: flex;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #d3d3d3;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/UsershiftsComponents/viewUserShifts.vue